import { useCallback } from 'react';
import { useRafState } from 'react-use';

export const useNodeRef = (): [HTMLElement | null, (node: any) => void] => {
  const [node, setNode] = useRafState<HTMLElement | null>(null);
  const ref = useCallback(
    (node) => {
      setNode(node);
    },
    [setNode]
  );

  return [node, ref];
};
